import React from 'react';
import {useHistory} from 'react-router-dom';
import {isDevelopment} from '../constants';
import QRCode, {QRCodeProps} from 'react-qr-code';
import {ANONYMOUS_ID_KEY} from './constants';
import {useAnonymousId} from '../hooks/useAnonymousId';

const DEFAULT_SCALE = 1;

const QrCode: React.FC<Omit<QRCodeProps, 'value'> & {value?: string}> = ({
  fgColor = '#001E50',
  bgColor = '#ffffff',
  size = 238,
  value = `${window.location.href}/app`,
  scale = DEFAULT_SCALE,
}) => {
  const {anonymousId} = useAnonymousId();
  const history = useHistory();

  const url = anonymousId
    ? `${value}?${ANONYMOUS_ID_KEY}=${anonymousId}`
    : value;

  return (
    <div
      style={{
        position: 'relative',
        transform: `scale(${scale})`,
        marginBottom: scale !== DEFAULT_SCALE ? -32 : 0,
      }}
    >
      <QRCode
        fgColor={fgColor}
        bgColor={bgColor}
        size={size}
        value={url}
        onClick={() => isDevelopment && history.push('/app')}
      />
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <circle cx="29" cy="29" r="29" fill={bgColor} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57.5599 28.9995C57.5599 44.8217 44.8222 57.5595 28.9999 57.5595C13.1777 57.5595 0.439941 44.8217 0.439941 28.9995C0.439941 13.1772 13.1777 0.439453 28.9999 0.439453C44.8222 0.439453 57.5599 13.1772 57.5599 28.9995ZM28.7228 22.8791C28.8003 23.0088 28.8643 23.1161 28.9999 23.1161C29.1713 23.1161 29.2284 23.0019 29.3427 22.7734L37.4537 4.49497C34.8262 3.52393 31.9702 3.00985 28.9999 3.00985C26.0297 3.00985 23.1737 3.52393 20.5462 4.49497L28.6572 22.7734C28.681 22.8091 28.7024 22.8449 28.7228 22.879L28.7228 22.8791ZM3.12451 28.9981C3.12451 43.221 14.777 54.9306 28.9999 54.9306C43.2228 54.9306 54.8752 43.221 54.9895 28.9981C54.9895 25.7994 54.4183 22.772 53.333 19.916L38.1962 50.361C38.0248 50.7608 37.7392 51.1035 37.2823 51.1035C36.8253 51.1035 36.5397 50.7608 36.3684 50.361L29.3997 34.7672C29.3759 34.7315 29.3545 34.6957 29.3341 34.6615C29.2567 34.5318 29.1926 34.4245 29.057 34.4245C28.8856 34.4245 28.7714 34.5959 28.7143 34.7672L21.7456 50.361C21.5743 50.7608 21.2887 51.1035 20.8317 51.1035C20.3748 51.1035 20.0892 50.7608 19.9178 50.361L4.78099 19.916C3.69571 22.772 3.12451 25.7994 3.12451 28.9981ZM20.7174 41.9078C20.5818 41.9078 20.5178 41.8005 20.4403 41.6708C20.4199 41.6366 20.3986 41.6009 20.3747 41.5651L7.23712 15.0614C9.57904 11.4629 12.7206 8.43549 16.5477 6.32205L26.0296 27.3993C26.1438 27.742 26.4294 27.8563 26.715 27.8563H31.2846C31.6274 27.8563 31.8558 27.7992 32.0272 27.3993L41.5091 6.32205C45.279 8.43549 48.4778 11.4629 50.8197 15.0614L37.5678 41.5651C37.5107 41.7364 37.3965 41.9078 37.2251 41.9078C37.0895 41.9078 37.0255 41.8005 36.948 41.6708L36.948 41.6707C36.9276 41.6366 36.9062 41.6008 36.8824 41.5651L31.913 30.2553C31.7416 29.8555 31.5131 29.7984 31.1704 29.7984H26.6008C26.2581 29.7984 26.0296 29.8555 25.8582 30.2553L21.0602 41.5651C21.003 41.7364 20.8888 41.9078 20.7174 41.9078Z"
          fill={fgColor}
        />
      </svg>
    </div>
  );
};

export default QrCode;
